import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

import {ProductType, productTypeName} from "@/shared/model/productType";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import Product from "@/shared/model/product";
import {mdiFileDocument, mdiStore, mdiWeb} from "@mdi/js";
import SogButton from "@/shared/ui/SogButton.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogSvgIcon from "@/shared/ui/SogSvgIcon.vue";
import {ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectProductComponent',
  setup(__props) {


const _shoppingCartStore = useShoppingCartStore();
const {currentItem, currentBaseProducts} = storeToRefs(_shoppingCartStore);

function onSelectBaseProduct(product: Product) {
  _shoppingCartStore.setBaseProduct(product);
}

const kzkButtonsGermany = ref([[{visible: false, value: new Product()}]]);
const kzkButtonsIvk = ref([[{visible: false, value: new Product()}]]);
const zollButtons = ref([[{visible: false, value: new Product()}]]);
const tzButtons = ref([[{visible: false, value: new Product()}]]);

const _hasKzk = ref(false)
const _hasGermany = ref(false)
const _hasIvk = ref(false)

watch(currentBaseProducts, () => {
  kzkButtonsGermany.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  kzkButtonsIvk.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  zollButtons.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  tzButtons.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  _hasKzk.value = false;
  _hasGermany.value = false;
  _hasIvk.value = false;

  if (currentBaseProducts.value) {
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId !== "Germany").map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_validityDay = t_product.validityDay ?? 5
      const t_row = t_validityDay - 1;
      _hasIvk.value = true;
      _hasKzk.value = true;
      kzkButtonsIvk.value[t_row][t_col].visible = true;
      kzkButtonsIvk.value[t_row][t_col].value = t_product;
    })
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === "Germany").map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_validityDay = t_product.validityDay ?? 5
      const t_row = t_validityDay - 1;
      _hasGermany.value = true;
      _hasKzk.value = true;

      kzkButtonsGermany.value[t_row][t_col].visible = true;
      kzkButtonsGermany.value[t_row][t_col].value = t_product;
    })

    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Zoll).map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_row = t_product.validityDay == 9 ? 0 : t_product.validityDay == 15 ? 1 : 2;
      zollButtons.value[t_row][t_col].visible = true;
      zollButtons.value[t_row][t_col].value = t_product;
    })
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Tz).map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_row = 0;
      tzButtons.value[t_row][t_col].visible = true;
      tzButtons.value[t_row][t_col].value = t_product;
    })

  }
}, {immediate: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(productTypeName)(_unref(currentItem).baseProductType)), 1)
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogFlexRow, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCard, null, {
                default: _withCtx(() => [
                  _createVNode(SogCardTitle, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Deutschland", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(SogCardContent, null, {
                    default: _withCtx(() => [
                      _createElementVNode("table", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kzkButtonsGermany.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", { key: row }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (button) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: button.value
                              }, [
                                _withDirectives(_createVNode(SogButton, {
                                  style: {"min-width":"65px"},
                                  onClick: ($event: any) => (onSelectBaseProduct(button.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(button.value.carTypeName), 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(_toDisplayString(button.value.validityDay) + " ", 1),
                                    _withDirectives(_createElementVNode("span", null, "Tag", 512), [
                                      [_vShow, button.value.validityDay===1]
                                    ]),
                                    _withDirectives(_createElementVNode("span", null, "Tage", 512), [
                                      [_vShow, button.value.validityDay!==1]
                                    ]),
                                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiWeb) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isJustInTime]
                                    ]),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiStore) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isStore]
                                    ]),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiFileDocument) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isStoreExportBlank]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]), [
                                  [_vShow, button.visible]
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _hasGermany.value]
              ]),
              _withDirectives(_createVNode(SogCard, null, {
                default: _withCtx(() => [
                  _createVNode(SogCardTitle, null, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("IVK", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(SogCardContent, null, {
                    default: _withCtx(() => [
                      _createElementVNode("table", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kzkButtonsIvk.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", { key: row }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (button) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: button.value
                              }, [
                                _withDirectives(_createVNode(SogButton, {
                                  style: {"min-width":"65px"},
                                  onClick: ($event: any) => (onSelectBaseProduct(button.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(button.value.carTypeName), 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(_toDisplayString(button.value.validityDay) + " ", 1),
                                    _withDirectives(_createElementVNode("span", null, "Tag", 512), [
                                      [_vShow, button.value.validityDay===1]
                                    ]),
                                    _withDirectives(_createElementVNode("span", null, "Tage", 512), [
                                      [_vShow, button.value.validityDay!==1]
                                    ]),
                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiWeb) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isJustInTime]
                                    ]),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiStore) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isStore]
                                    ]),
                                    _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiFileDocument) }, null, 8, ["icon"]), [
                                      [_vShow, button.value.isStoreExportBlank]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]), [
                                  [_vShow, button.visible]
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _hasIvk.value]
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _hasKzk.value]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zollButtons.value, (row) => {
            return _withDirectives((_openBlock(), _createBlock(SogFlexRow, {
              key: row,
              style: {"justify-content":"left"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (button) => {
                  return _withDirectives((_openBlock(), _createBlock(SogButton, {
                    key: button.value,
                    style: {"min-width":"65px"},
                    onClick: ($event: any) => (onSelectBaseProduct(button.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(button.value.carTypeName), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(button.value.validityDay) + " Tage ", 1),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiWeb) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isJustInTime]
                      ]),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiStore) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isStore]
                      ]),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiFileDocument) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isStoreExportBlank]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_vShow, button.visible]
                  ])
                }), 128))
              ]),
              _: 2
            }, 1024)), [
              [_vShow, zollButtons.value.some(t=>t.some(b=>b.visible))]
            ])
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tzButtons.value, (row) => {
            return _withDirectives((_openBlock(), _createBlock(SogFlexRow, {
              key: row,
              style: {"justify-content":"left"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (button) => {
                  return _withDirectives((_openBlock(), _createBlock(SogButton, {
                    key: button.value,
                    onClick: ($event: any) => (onSelectBaseProduct(button.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(button.value.carTypeName) + " ", 1),
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiWeb) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isJustInTime]
                      ]),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiStore) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isStore]
                      ]),
                      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiFileDocument) }, null, 8, ["icon"]), [
                        [_vShow, button.value.isStoreExportBlank]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_vShow, button.visible]
                  ])
                }), 128))
              ]),
              _: 2
            }, 1024)), [
              [_vShow, tzButtons.value.some(t=>t.some(b=>b.visible))]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})